// extracted by mini-css-extract-plugin
export var container = "_5n-0";
export var fallback = "_5n-5";
export var fallbackIcon = "_5n-6";
export var hidden = "_5n-2";
export var image = "_5n-3";
export var loaded = "_5n-4";
export var placeholder = "_5n-1";